import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  DtpContentContainer,
  DtpNoContent,
} from 'dtp-react-components';
import {
  Button,
  DataGrid,
  Grid,
  Input,
  Table,
} from '../../../components/index';
import {
  validateObject,
  requestValoresMediosBeneficios,
} from '../../../utils/requests';
import Masks from '../../../utils/masks';
import ModalValorMedioBeneficio from './ModalValorMedioBeneficio';
import { manterApenasFiltro } from '../../../utils/helpers';
import * as listUtils from '../../../utils/listsSelect';

class ValorMedioBeneficio extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }
  getInitialState = () => ({
    valorMedioBeneficio: {
      dataCompetencia: null,
      valorMedioBeneficio: null,
    },
    valorMedioBeneficioAlteracao: {
      dataCompetencia: null,
      valorMedioBeneficio: null,
    },
    valorMedioBeneficioValidacao: {
      dataCompetencia: null,
      valorMedioBeneficio: null,
      ano: null,
      mes: null,
    },
    validadeCampos: {
      // dataCompetencia: false,
      valorMedioBeneficio: false,
    },
    acaoModal: null,
    acao: 'novo',
    estadoFormulario: 'inicial',
    noContentPrimaryMessage: 'Valor não encontrado para o período informado.',
    noContentSecondaryMessage: 'Informe outro período.',
    showPeriodoModal: false,
    showValorMedioBeneficioModal: false,
  });

  componentDidMount() {
    manterApenasFiltro('');
    this.montaFormulario();
  }

  buscarValoresMediosBeneficios = (dataCompetencia) => {
    requestValoresMediosBeneficios(this.handleErrorBusca, dataCompetencia);
  }

  montaFormulario = () => {
    let paramCompetencia = '';
    if (this.state.valorMedioBeneficio.dataCompetencia) {
      paramCompetencia = this.state.valorMedioBeneficio.dataCompetencia;
    }
    this.setState(this.buscarValoresMediosBeneficios(paramCompetencia));
    this.setState({
      validadeCampos: {
        ...this.state.validadeCampos,
        dataCompetencia: false,
        valorMedioBeneficio: false,
      },
    });
  }

  montaValidadeCampos = (valorMedioBeneficio) => {
    const { validadeCampos } = { ...this.state };
    Object.keys(valorMedioBeneficio).forEach((key) => {
      validadeCampos[key] = true;
    });
    return validadeCampos;
  }

  handleErrorBusca = (error) => {
    if (error) {
      // const { data } = { ...error };
      if (error.status === 404) {
        let competenciaInvalida = false;
        if (this.state.validadeCampos.dataCompetencia) {
          if (this.state.valorMedioBeneficio.dataCompetencia.indexOf('_') !== -1) {
            competenciaInvalida = true;
          }
        }
        if (!competenciaInvalida) {
          this.state.valorMedioBeneficioAlteracao.dataCompetencia =
          this.state.valorMedioBeneficio.dataCompetencia;
          this.setState({
            showValorMedioBeneficioModal: !this.state.showValorMedioBeneficioModal,
            valorMedioBeneficioAlteracao: this.state.valorMedioBeneficioAlteracao,
            acaoModal: 'criar',
            acao: 'novo',
          });
        }
        this.setState({
          valorMedioBeneficio: {
            dataCompetencia: null,
          },
          validadeCampos: {
            dataCompetencia: false,
          },
        });
      }
    }
  }
  /**
   * Para o Formulario estar pronto para envio, deve:
   *  - Ser criacao (acao=novo) e ter todos seus campos validos;
   *  - Ser criacao:
   *     - ter sido enviado com falha em regra de negocio e;
   *     - pelo menos um campo alterado para valido.
   */
  formularioProntoParaEnvio = () => {
    const { acao } = { ...this.state };
    const { estadoFormulario } = { ...this.state };
    switch (acao) {
      case 'novo': {
        if (estadoFormulario === 'inicial') {
          return validateObject(this.state.validadeCampos);
        }
        if (estadoFormulario === 'criado') {
          return true;
        }
        return estadoFormulario === 'alterado';
      }
      default: return false;
    }
  }
  // this.setState({
  //   requerimento: {
  //     ...requerimento,
  //     [name]: changeObj.value,
  //   },
  //   validadeCampos: {
  //     ...this.state.validadeCampos,
  //     [name]: changeObj.isValid,
  //   },
  //   estadoFormulario,
  // }, callback);

   handleChange = (changeObj, name, callback = null) => {
     const { valorMedioBeneficio } = { ...this.state };
     this.setState({
       valorMedioBeneficio: {
         ...valorMedioBeneficio,
         [name]: changeObj.value,
       },
       validadeCampos: {
         ...this.state.validadeCampos,
         [name]: changeObj.isValid,
       },
     }, callback);
   }

  handleKeyUp = (e) => {
    let retorno = e.target.value;
    if (retorno.indexOf('_') !== -1) {
      retorno = retorno.toString().replace('_', '');
    }
    retorno = retorno.toString().replace(/\D/g, '');
    retorno = retorno.toString().replace(/(\d)(\d{11})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{8})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{5})$/, '$1.$2');
    retorno = retorno.toString().replace(/(\d)(\d{2})$/, '$1,$2');
    e.target.value = retorno;

    return retorno;
  }
  /**
   * Trata o click no botão de busca por competencia.
   */
  handleSearchButton = () => {
    this.setState({ ...this.state }, this.handleSearch);
  }

  handleSearch = () => {
    let paramCompetencia = this.state.valorMedioBeneficio.dataCompetencia;
    if (this.state.validadeCampos.dataCompetencia) {
      const comp = paramCompetencia;
      if (comp.toString().length > 6) {
        if (comp === '__/____') {
          paramCompetencia = '';
          this.setState(this.buscarValoresMediosBeneficios(paramCompetencia));
        } else {
          const competenciaComBarra = this.state.valorMedioBeneficio.dataCompetencia;
          const competenciaPrimaParte = competenciaComBarra.substring(0, competenciaComBarra.indexOf('/'));
          const competenciaSeguParte = competenciaComBarra.substring(competenciaComBarra.indexOf('/') + 1, competenciaComBarra.toString().length);
          paramCompetencia = competenciaPrimaParte + competenciaSeguParte;
        }
        this.setState(this.buscarValoresMediosBeneficios(paramCompetencia));
      }
    } else {
      paramCompetencia = '';
      this.setState(this.buscarValoresMediosBeneficios(paramCompetencia));
    }
  }

  handleModal = (row, tipo) => {
    this.state.valorMedioBeneficioAlteracao.dataCompetencia = row.competencia;
    this.state.valorMedioBeneficioAlteracao.valorMedioBeneficio = row.valorMedioBeneficio;
    this.setState({
      showValorMedioBeneficioModal: !this.state.showValorMedioBeneficioModal,
      tipo,
      valorMedioBeneficioAlteracao: this.state.valorMedioBeneficioAlteracao,
    });
  };

  pesquisar = (
    <Button
      title="Pesquisar"
      onClick={() => this.handleSearchButton()}
      hint="Pesquisar valor da média pela competência"
    />
  );

  handleClickCarregarAlteracao = (row, tipo) => {
    this.setState({
      acaoModal: 'alterar',
      acao: 'alterar',
    });
    this.handleModal(row, tipo);
  };

  montaAcaoCargaAlteracao = (row, tipo) => (
    <Button
      hint="Alterar competência"
      icon="ico-doc-pencil"
      mini
      onClick={() => this.handleClickCarregarAlteracao(row, tipo)}
    />
  );

  createActionColumn = (cell, row) => (
    // Defeito 291695
    // const acoes = this.montaAcaoCargaAlteracao(row, 'modo-alteracao');
    // if (!row.exibirBotaoAlteracao) {
    //   acoes = '';
    // }
    // return acoes;
    this.montaAcaoCargaAlteracao(row, 'modo-alteracao')
  );

  options = {
    noDataText: 'Nenhuma competência cadastrada',
    hideSizePerPage: false,
    sizePerPage: 10,
    sizePerPageList: listUtils.linhasPorPagina,
  };

  montaColunas = () => {
    const valorMedioBeneficioTableHeader = this.tableHeader.slice();
    if (this.props.auth.checkPermission(['analisar-negocio-sprev'])) {
      valorMedioBeneficioTableHeader.push({
        id: 'acao',
        label: 'Ação',
        dataFormat: this.createActionColumn,
      });
    }
    return valorMedioBeneficioTableHeader;
  }

  tableHeader = [{
    id: 'competencia',
    label: 'Competência',
  }, {
    id: 'valorMedioBeneficio',
    label: 'Valor da Média',
  }];

  render() {
    if (this.state.reset) {
      return null;
    }

    if (this.state.showNoContent) {
      return (
        <DtpNoContent
          primaryText={this.state.noContentPrimaryMessage}
          secondaryText={this.state.noContentSecondaryMessage}
          show={this.state.showNoContent}
        />);
    }

    const valorMedioBeneficioTableHeader = this.montaColunas();

    const retorno = (
      <DtpContentContainer>
        <DataGrid title="Valor da Média do Benefício" icon="ico-money" >
          <div className="row">
            <Grid cols="4 4 4 4">
              <Input
                mask={Masks.competencia}
                label="Competência"
                onChange={e => this.handleChange(e, 'dataCompetencia')}
                value={this.state.valorMedioBeneficio.dataCompetencia}
              />
            </Grid>
            {this.pesquisar}
          </div>
        </DataGrid>
        <Table
          bordered
          data={this.props.valoresMediosBeneficios}
          options={this.options}
          listaTableHeader={valorMedioBeneficioTableHeader}
          pagination
          scrollTop="Top"
        />
        {this.state.showValorMedioBeneficioModal ? (
          <ModalValorMedioBeneficio
            auth={this.props.auth}
            acao={this.state.acao}
            acaoModal={this.state.acaoModal}
            valorMedioBeneficioAlteracao={this.state.valorMedioBeneficioAlteracao}
            handleModal={() => this.handleModal('showValorMedioBeneficioModal')}
            showModal={this.state.showValorMedioBeneficioModal}
            estadoFormulario={this.state}
            handleChange={this.handleChange}
            handleKeyUp={this.handleKeyUp}
            handleBlur={this.handleBlur}
          />
        ) : ''}
      </DtpContentContainer>
    );
    return retorno;
  }
}

ValorMedioBeneficio.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      protocolo: PropTypes.string,
      acao: PropTypes.string,
    }),
  }),
  history: PropTypes.shape({
    goBack: PropTypes.function,
  }).isRequired,
  auth: PropTypes.shape({
    userData: PropTypes.object,
    checkPermission: PropTypes.func,
  }),
  valoresMediosBeneficios: PropTypes.arrayOf(PropTypes.shape({
    competencia: PropTypes.string,
    valorMedioBeneficio: PropTypes.string,
  })),
};

ValorMedioBeneficio.defaultProps = {
  match: null,
  auth: null,
  valoresMediosBeneficios: null,
};
const mapStateToProps = state => ({ valoresMediosBeneficios: state.base.valoresMediosBeneficios });

export default connect(mapStateToProps)(ValorMedioBeneficio);



// WEBPACK FOOTER //
// ./src/pages/cadastros/ValoresMediosBeneficios/ValorMedioBeneficio.jsx